/**
 * Dropdown Navigation Update Script
 * 
 * This script updates a dropdown menu based on the user's scroll position.
 * It highlights the current section in view within a single-page layout.
 * The script only runs if the in-page navigation is present on the page.
 * It truncates the dropdown text to 20 characters, adding an ellipsis if longer.
 */

(function() {
    'use strict';

    document.addEventListener('DOMContentLoaded', initializeScript);

    function initializeScript() {
        // Check if in-page navigation is present
        const inPageNav = document.querySelector('.in-page-nav--mob');
        if (!inPageNav) {
            // If in-page navigation is not present, exit the script
            return;
        }

        // DOM elements
        const singleGuide = document.querySelector('.single-guide');
        const dropdownToggle = document.querySelector('.dropdown-toggle');
        const dropdownCurrent = document.querySelector('.dropdown-current');
        const dropdownItems = document.querySelectorAll('.dropdown-item');

        // Check if all required elements are present
        if (!singleGuide || !dropdownToggle || !dropdownCurrent || dropdownItems.length === 0) {
            // If any required element is missing, exit the script
            return;
        }

        // Constants
        const THRESHOLD = 200; // Pixels from the top of the viewport
        const MAX_TEXT_LENGTH = 20; // Maximum number of characters for dropdown text

        function truncateText(text, maxLength) {
            if (text.length <= maxLength) return text;
            return text.slice(0, maxLength) + '...';
        }

        function updateDropdownCurrent() {
            const viewportTop = window.scrollY;
            const elements = Array.from(singleGuide.querySelectorAll('[id]')).reverse();
            let lastVisibleElement = null;

            // Find the last visible element
            for (let element of elements) {
                const elementTop = element.getBoundingClientRect().top + viewportTop;
                if (elementTop <= viewportTop + THRESHOLD) {
                    lastVisibleElement = element;
                    break;
                }
            }

            // Update dropdown text if a visible element is found
            if (lastVisibleElement) {
                const id = lastVisibleElement.id;
                for (let item of dropdownItems) {
                    if (item.getAttribute('href') === '#' + id) {
                        dropdownCurrent.textContent = truncateText(item.textContent, MAX_TEXT_LENGTH);
                        return;
                    }
                }
            }

            // Reset dropdown text if no element is found
            dropdownCurrent.textContent = 'Jump to section...';
        }

        // Event listeners
        window.addEventListener('load', updateDropdownCurrent);
        window.addEventListener('scroll', updateDropdownCurrent);
        dropdownToggle.addEventListener('click', () => setTimeout(updateDropdownCurrent, 100));
    }
})();